module.exports = __webpack_public_path__ + "img/chat-solid-black.e6bc991.svg";